const EventEmitter = require("events");

// To listen to the pressing of a character key, use onChar. The first argument
// will be a length 1 string with the pressed character. The second argument
// will be the original event.

// To listen to the pressing of a special key, use onSpecial. The first
// argument will be the name of the special key. The second argument will be
// the original event. Special key names are readable below in the onKeyDown
// function body.

// In all cases, if you want to prevent the default behavior of the press,
// you must call preventDefault in the handler yourself.

if (typeof window !== "undefined" && typeof document !== "undefined") {
	const emitter = new EventEmitter();
	const onKeyPress = function(evt) {
		const key = String.fromCharCode(evt.charCode);
		if (key.length) {
			emitter.emit("char", evt, key);
		}
	};

	// Generic key event handler. Given an event name, returns a function
	// that takes an event, and dispatches an event with the given name
	// passing the event and special key pressed
	const makeOnKeyFunction = function(eventName) {
		return evt => {
			if (evt.which === 13) {
				emitter.emit(eventName, evt, "enter");
			} else if (evt.which === 9 && evt.shiftKey) {
				emitter.emit(eventName, evt, "shifttab");
			} else if (evt.which === 9) {
				emitter.emit(eventName, evt, "tab");
			} else if (evt.which === 8) {
				emitter.emit(eventName, evt, "backspace");
			} else if (evt.which === 46) {
				emitter.emit(eventName, evt, "delete");
			} else if (evt.which === 33) {
				emitter.emit(eventName, evt, "pageup");
			} else if (evt.which === 34) {
				emitter.emit(eventName, evt, "pagedown");
			} else if (evt.which === 36) {
				emitter.emit(eventName, evt, "home");
			} else if (evt.which === 35) {
				emitter.emit(eventName, evt, "end");
			} else if (evt.which === 37) {
				emitter.emit(eventName, evt, "left");
			} else if (evt.which === 38) {
				emitter.emit(eventName, evt, "up");
			} else if (evt.which === 39) {
				emitter.emit(eventName, evt, "right");
			} else if (evt.which === 40) {
				emitter.emit(eventName, evt, "down");
			} else if (evt.which === 65 && (evt.ctrlKey || evt.metaKey)) {
				emitter.emit(eventName, evt, "ctrl+a");
			} else if (evt.which === 89 && (evt.ctrlKey || evt.metaKey)) {
				emitter.emit(eventName, evt, "ctrl+y");
			} else if (
				evt.which === 90 &&
				evt.shiftKey &&
				(evt.ctrlKey || evt.metaKey)
			) {
				emitter.emit(eventName, evt, "ctrl+shift+z");
			} else if (evt.which === 90 && (evt.ctrlKey || evt.metaKey)) {
				emitter.emit(eventName, evt, "ctrl+z");
			} else if (evt.which === 27) {
				emitter.emit(eventName, evt, "esc");
			}
		};
	};
	const onKeyDown = makeOnKeyFunction("special");

	const emitChar = function(evt, char) {
		emitter.emit("char", evt, char);
	};
	const emitSpecial = function(evt, code) {
		emitter.emit("special", evt, code);
	};

	document.addEventListener("keypress", onKeyPress);
	document.addEventListener("keydown", onKeyDown);

	module.exports = {
		onChar: handler => emitter.addListener("char", handler),
		offChar: handler => emitter.removeListener("char", handler),
		onSpecial: handler => emitter.addListener("special", handler),
		offSpecial: handler => emitter.removeListener("special", handler),
		emitChar: emitChar,
		emitSpecial: emitSpecial,
	};
} else {
	module.exports = {
		onChar: () => {},
		offChar: () => {},
		onSpecial: () => {},
		offSpecial: () => {},
	};
}
